import { HiArrowNarrowRight } from "react-icons/hi";
import React from "react";

const Button = (props) => {
  const { onClickHandler, text } = props;
  return (
    <button
      onClick={onClickHandler}
      className=" text-white text-md group font-bold px-5 py-4 my-2 border-2 flex items-center hover:bg-pink-600 hover:border-pink-600 focus:bg-pink-600"
    >
      {text}
      <span className="ml-3 group-hover:rotate-90 group-focus:rotate-90 duration-300">
        <HiArrowNarrowRight />
      </span>
    </button>
  );
};

export default Button;
